export function onlyDate(datetime) {
  return datetime.split(' ')[0]
}
export function createFormatTime(stringTime) {
  var timezoneOffset = new Date().getTimezoneOffset()
  var utcDate = Date.parse(stringTime.replace(/-/g, '/'))
  utcDate -= timezoneOffset * 60 * 1000
  return formatTime(utcDate)
}
export function formatTime (dateTime) {
  if (!dateTime) return ''
  dateTime = new Date(dateTime)
  var year = dateTime.getFullYear()
  var month = dateTime.getMonth() + 1
  var date = dateTime.getDate()
  var hour = dateTime.getHours()
  var minutes = dateTime.getMinutes()
  var seconds = dateTime.getSeconds()
  month = month < 10 ? '0' + month : month
  date = date < 10 ? '0' + date : date
  hour = hour < 10 ? '0' + hour : hour
  minutes = minutes < 10 ? '0' + minutes : minutes
  seconds = seconds < 10 ? '0' + seconds : seconds
  let lang = window.localStorage.getItem("currentLang"), dateStr = ''
  if (lang === 'en') {
    dateStr = month + '/' + date + '/' + year
  } else {
    dateStr = year + '-' + month + '-' + date
  }
  return dateStr + ' ' + hour + ':' + minutes + ':' + seconds
}



// WEBPACK FOOTER //
// ./src/lib/filters.js